import { useState } from "react"
import { FaStar } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

function PatnerReviews() {
    const location = useLocation();
    const date = new Date();
    const dateFormate = date.toDateString().substring(4, 15)
    const navigate=useNavigate();
    console.log("date", date)
    const [reviews, setReviews] = useState([
        { patnerName: "Chinni", votsCount:35, feedback: "Sweet voice chinni", rating: 5, time: dateFormate, albumRoom: location.state.name },
        { patnerName: "Rajesh", votsCount:20, feedback: "I'm big fan of your voice", rating: 5, time: dateFormate, albumRoom: location.state.name },
        { patnerName: "Sravya", votsCount:10, feedback: "Nice", rating: 5, time: dateFormate, albumRoom: location.state.name },
    ])
    const pollData = [
      { patnerName: 'Chinni', percentage: 90 },
      { patnerName: 'Rajesh', percentage: 85 },
      { patnerName: 'Sravya', percentage: 30 },
    ];
    console.log("review", reviews)
    const participenReview=(participentName)=>{
       navigate("/participentReview",{state:{name:participentName}})
    }
    return (
        <>
            <div className="container-fluid dashboard">
                <div className="row d-flex flex-row justify-content-between">
                    {
                        reviews.map((obj, i) => {
                            return (
                                <>
                                    <div className="col-4 mt-3 " onClick={()=>participenReview(obj.patnerName)}>
                                        <div className="hover-box">
                                            <div className="p-3">
                                                <h6 className="" style={{ color: "green", marginLeft: 10 }}>{obj.patnerName}</h6>
                                                <p className="" style={{ marginLeft: 10 }}>{obj.albumRoom}</p>
                                                <div style={{ marginLeft: 10 }}>

                                                    <span style={{ fontWeight: 600 }}>Vots {obj.votsCount}</span>
                                                    <span style={{ marginLeft: 10, color: "#B2BEB5" }}>{obj.time}</span>
                                                    <span style={{ marginLeft: 5, color: "#B2BEB5" }}>{date.getHours()}:{date.getMinutes()}</span>

                                                    <p>{obj.feedback}</p>
                                                    <span>

                                                        {[...Array(obj.rating)].map((_, i) => (
                                                            <FaStar key={i} color="gold" />
                                                        ))}

                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )
                        })
                    }
                </div>
                <div className="row mt-5">
                    <div className="col-5">
                        <div style={{ width: '100%', height: 400 }}>
                        <h3 style={{ textAlign: 'center' }}>Poll Results</h3>
                        <ResponsiveContainer>
                            <BarChart data={pollData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="patnerName" />
                                <YAxis />
                                <Tooltip />
                                <Bar dataKey="percentage" fill="#4caf50" barSize={30} />
                            </BarChart>
                        </ResponsiveContainer>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default PatnerReviews